export const HIDE_SIGNAL = 'hide';
export const DISPLAY_SIGNAL = 'display';
export const IMAGE_LOAD_ERROR_CODE = 502;
export const DEFAULT_IMAGE_LOAD_TIMEOUT_IN_SECONDS = 5;
